import Card from "@mui/material/Card";
import { Button, CardActions, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { pathRoute } from "../Routes/routes";
import { useNavigate } from "react-router-dom";

export default function Page404() {
  const navigate = useNavigate();
  return (
    <>
      <Grid container>
        <Card variant="outlined">
          <CardContent>
            <Grid item>
              <Typography gutterBottom variant="h2" component="h2" display="initial">
                {"PageNotFound"}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                {"PageNotFoundSubtitle"}
              </Typography>
            </Grid>
            <CardActions>
              <Button
                color="primary"
                onClick={() => {
                  navigate(pathRoute.Dashboard, { replace: true });
                }}
              >
                {"GoDashboard"}
              </Button>
            </CardActions>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
}
